import { z } from 'zod'
import { instructionSchema } from './instruction'

/** {@link https://solana.com/docs/rpc/json-structures#inner-instructions} */
export const innerInstructionSchema = z.object({
  /** Index of the transaction instruction from which the inner instruction(s) originated */
  index: z.number(),
  /** Ordered list of inner program instructions that were invoked during a single transaction instruction. */
  instructions: z.array(instructionSchema),
})
